import React from "react";
import * as S from "./styles";
import { ArrowForwardIos, ShoppingCartOutlined } from "@material-ui/icons";
import { Item } from "../Item";
import ProductEdit from "./ProductEdit";
import { toast } from "react-toastify";
import { API } from "../../../../../shared/services";
import * as http from "../../../utils/http/products";

import { ProductList } from "./styles";
import { useTranslation } from "react-i18next";
import ProductNew from "./ProductNew";
import { ProductItem } from "../ProductItem";
import { Action } from "../SoldProducts/styles";
import { useContacts, useContactsState } from "../../../contexts/contact/hook";

export default function Products({ customer }) {
  const { currentContact } = useContactsState();
  const { t } = useTranslation(["Customer", "common"]);
  const { setSpotlight } = useContacts();
  const { updateCurrentContact } = useContacts();

  function handleDeleteProduct(product) {
    if (
      product?.channel_id !== 1 &&
      window.confirm(t("details.products.sure"))
    ) {
      http
        .deleteProducts(customer, product)
        .then(() => {
          updateCurrentContact({
            ...customer,
            products: customer?.products.filter(
              (prod) => prod?.id !== product?.id
            ),
          });

          toast.success(t("details.products.removed"));
        })
        .catch(() => toast.error(t("details.products.removed_error")));
    } else toast.error(t("details.products.manually_removed"));
  }

  return (
    <Item
      leftAction={<ShoppingCartOutlined />}
      title={`${t("details.products.title")}`}
    >
      <ProductList>
        {currentContact.products.map((product) => (
          <ProductItem
            handleRemove={() => {
              handleDeleteProduct(product);
            }}
            product={product}
            className="selectable"
            key={product.id}
            handleClick={() =>
              setSpotlight(
                <ProductEdit customer={currentContact} product={product} />
              )
            }
          />
        ))}
      </ProductList>

      <Action
        onClick={() => setSpotlight(<ProductNew customer={currentContact} />)}
      >
        <S.NewProdItem>{t("details.products.add_new")}</S.NewProdItem>
        <ArrowForwardIos />
      </Action>
    </Item>
  );
}
